import * as types from '../reducers/types'

const initialState = {
  allClientList:[],
  courses:{},
  activeClient:{},
  // true from the moment a client is picked until its courses arrive
  coursesLoading:false
}


const clientReducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case types.ALL_CLIENT_RES:
            let list = [];
            if(action?.payload?.status === "success"){
                list = action?.payload?.data;
            }
            return {
                ...state,
                allClientList:list,
                
            }
        case types.LOGGEDIN_CLIENT_COURSES_RES:
                let crs = [];
                if(action?.payload?.status === "success"){
                    crs = action?.payload?.data;
                }
                return {
                    ...state,
                    courses:crs,
                    coursesLoading:false,

             }
        case types.LOGGEDIN_CLIENT_COURSES_REQ:
        return {
            ...state,
            activeClient:action?.payload,
            // drop the previous client's courses so they cannot be shown
            // while the new ones are on the way
            courses:{},
            coursesLoading:true,

        }
        case types.LOGGEDOUT_CLIENT_COURSES_REQ:
                /* back to a clean slate - activeClient used to survive a
                   logout, which also left the next user gated on the previous
                   user's client */
                return {
                    ...state,
                    courses:{},
                    allClientList:[],
                    activeClient:{},
                    coursesLoading:false,
                }
        default:
            return state
    }
}

export default clientReducer